import React from 'react';

import Features from '@dashboard/enums/features';

import usePage from '@dashboard/hooks/usePage';

import CanUseFeature from '@dashboard/components/CanUseFeature';

import PageEditView from '../components/PageEditView';
import { editorSection } from '../pageEditTabs';

import EmailConfirmationForm from './PageSettings/components/EmailConfirmationForm';
import FunnelStepsForm from './PageSettings/components/FunnelStepsForm';
import PageConfirmationForm from './PageSettings/components/PageConfirmationForm';

export const getAfterPaymentSections = ({ page }) => {
  const context = { page };
  const section = path => editorSection('after-payment', path, context);

  return [
    {
      ...section('/confirmation'),
      component: <PageConfirmationForm />,
      description:
        page.type === 'form'
          ? 'What your customer sees after submitting the form.'
          : 'What your customer sees after successful payment.',
      helpUrl:
        page.type === 'form'
          ? undefined
          : '/docs/articles/how-do-I-display-a-confirmation-message-after-successful-checkout',
    },
    {
      ...section('/email-confirmation'),
      component: <EmailConfirmationForm />,
      description:
        page.type === 'form'
          ? 'What your customer receives after submitting the form.'
          : 'What your customer receives after successful payment.',
      helpUrl:
        page.type === 'form'
          ? undefined
          : '/docs/articles/how-do-I-send-an-email-confirmation-after-successful-checkout',
    },
    {
      ...section('/one-click-upsell'),
      component: (
        <CanUseFeature feature={Features.ONE_CLICK_UPSELLS}>
          <FunnelStepsForm />
        </CanUseFeature>
      ),
      description: 'Show an additional one-click offer after successful payment.',
      helpUrl: '/docs/articles/how-to-set-up-one-click-upsells',
    },
  ].filter(tab => tab.isVisible(context));
};

const PageAfterPayment = () => {
  const { page } = usePage();

  return <PageEditView tabs={getAfterPaymentSections({ page })} />;
};

export default PageAfterPayment;
